import { createFileRoute } from "@tanstack/react-router";
import { ConversationWorkspace } from "@/features/conversations/conversation-workspace";

export const Route = createFileRoute("/_authenticated/$store/conversations/$conversationId")({
  component: ConversationWorkspace,
});
